import { fnNoOp, len, throwIf } from "./util";

const menuSeparator = "---";

export class MenuItem {
  label = "";
  shortcut = "";
  handler: (() => void) | null;
  items: MenuItem[] = [];

  constructor(l: string, h: (() => void) | null, items: MenuItem[] = []) {
    throwIf(!l, "needs label");
    throwIf(!h && l != menuSeparator && len(items) == 0, "needs handler");
    this.label = l;
    this.handler = h;
    this.items = items;
  }
  get isShowing() {
    return len(this.items) > 0;
  }
  isSeparator() {
    return this.label == menuSeparator;
  }
  isSubMenu() {
    return len(this.items) > 0;
  }
}

export const menuItemSeparator = new MenuItem(menuSeparator, fnNoOp);

export function makeSubMenu(l: string, items: MenuItem[]): MenuItem {
  return new MenuItem(l, null, items);
}
